import { render, staticRenderFns } from "./YA_barTag.vue?vue&type=template&id=236835f6&scoped=true"
import script from "./YA_barTag.vue?vue&type=script&lang=js"
export * from "./YA_barTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236835f6",
  null
  
)

export default component.exports